import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../BuilderInfoUI';
import EventConditionInfo from './EventConditionInfo';
import { IEventConditionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { theme } from '../../../styles/theme';

interface IProps {
  subjectName: string;
  triggerCondition: IEventConditionFieldsFragment;
}

const Container = styled(BuilderInfoUI.Content)`
  position: relative;
  display: grid;
  grid-template-columns: min(70px) 1fr;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: 28px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${theme.colors.border};
  }
`;

export default ({ subjectName, triggerCondition }: IProps) => (
  <Container>
    <BuilderInfoUI.PlainInfo>
      <BuilderInfoUI.InfoLabel>Subject</BuilderInfoUI.InfoLabel>
      <BuilderInfoUI.PlainValue>{subjectName}</BuilderInfoUI.PlainValue>
    </BuilderInfoUI.PlainInfo>
    <EventConditionInfo
      label={'Trigger Event(s)'}
      condition={triggerCondition}
      noMarginBottom={true}
    />
  </Container>
);
